module.exports = __webpack_public_path__ + "static/media/S3N4-6.8eb7ee0a.svg";